import React, { PureComponent } from 'react';
import ButtonSpinner from '../../../shared/UI/button-spinner';
import { connect } from 'react-redux';
import { withApollo } from 'react-apollo'; 
import { UpdateSector } from '../../../../actions/booking';
import dayjs from 'dayjs';
import CalendarSvg from '../../../shared/UI/calendarSvg';
import CheckSvg from '../../../shared/UI/checkSvg';
import { pluralHelper } from '../../../../helpers/stringutils';

class DaysPanel extends PureComponent {

  constructor(props){
    super(props);
    this.state = {
      nights:props.nights || 0,
      nightsTouched:false
    }
    this.closeClicked = this.closeClicked.bind(this);
    this.onNightsChange = this.onNightsChange.bind(this);
    this.onCheckHandler = this.onCheckHandler.bind(this);
  }

  componentDidMount(){
    this.setState({nights:this.props.nights || 0});
  }

  closeClicked(){
    this.props.onCloseClicked();
  }

  onNightsChange(direction){

    const { nights } = this.state;

    if(direction === 'down'){
      if(nights > 0) this.setState({nights: nights - 1, nightsTouched:true});
    }
    if(direction === 'up'){
      if(nights < 10) this.setState({nights: nights + 1, nightsTouched:true});
    }

  }

  onCheckHandler(){
  
    const { client, index, uuid, itinerary } = this.props;
    const updatedDate = dayjs(itinerary[index].date).add(this.state.nights, 'days').format('YYYY-MM-DD');
    
    this.setState({isLoading:true});
    UpdateSector(client, uuid, parseInt(itinerary[index].id, 10), parseInt(this.state.nights, 10), index !== 0 ? updatedDate : null, true, true).then(()=>{
      this.setState({isLoading:false});
      this.closeClicked();
    });
  
  }

  render(){

    const { nightsTouched } = this.state;
    const { isLoading } = this.props;

    return (
      <div className="panel small-panel days round-corners">

        <div className={`clearfix flex ${isLoading ? 'loading' : ''}`}>
          <div className="col col-4 md-col-7 flex items-center">
            <CalendarSvg clazz={"mr2"}/> <span className="bold uppercase f-size-16 xs-hide">Duration</span>
          </div>
          <div className="col col-7 md-col-4 flex justify-end">

            <button type="button" className={`${(this.state.nights === 0) ? "disabled": ""}`} onClick={e => this.onNightsChange('down')}>
                <span className="down-button"><svg className="nights inline-block" viewBox="0 0 24 24" role="img" aria-label="subtract" focusable="false" style={{'height':'1.5em', 'width': '1.5em', 'display': 'block', 'fill': 'currentcolor' }}><rect height="2" rx="1" width="12" x="6" y="11"></rect></svg></span>
            </button>

            <span className="pax-number f-size-14">{this.state.nights} {pluralHelper("Night", this.state.nights)}</span>

            <button type="button" className={`${(this.state.nights === 10) ? "disabled": ""}`} onClick={e => this.onNightsChange('up')}>
                <span><svg className="nights inline-block" viewBox="0 0 25 25" role="img" aria-label="add" focusable="false" style={{'height':'1.5em', 'width': '1.5em', 'display': 'block', 'fill': 'currentcolor' }}><rect height="2" rx="1" width="12" x="6" y="11"></rect><rect height="12" rx="1" width="2" x="11" y="6"></rect></svg></span>
            </button>

          </div>
          <div className="col col-1 md-col-1 flex justify-end items-center">
             {
               nightsTouched ? 
               <CheckSvg clazz={`button`} fill={"#ff6700"} onClickHandler={this.onCheckHandler}/>  : 
               <svg className="inline-block button" xmlns="http://www.w3.org/2000/svg" height="22.627" width="22.627" onClick={this.closeClicked}>
                <path fill="#3D3D3D" transform="rotate(45 11.314 11.314)" fillRule="evenodd" d="M18.98 10.314h-6.666V3.647a.333.333 0 0 0-.334-.333h-1.333a.333.333 0 0 0-.333.333v6.667H3.647a.333.333 0 0 0-.333.333v1.333c0 .185.149.334.333.334h6.667v6.666c0 .185.149.334.333.334h1.333c.185 0 .334-.15.334-.334v-6.666h6.666c.185 0 .334-.15.334-.334v-1.333"/>
              </svg>
             } 
          </div>
        </div>

        { isLoading && <div className="clearfix flex loading-spinner days">
          <div className="col col-12 flex items-center">
            <ButtonSpinner />
          </div>
        </div> 
        }         

      </div>
    )
  }

}


const mapStateToProps = state => {
  return{
      itinerary:state.currentBooking.itinerary,
      uuid:state.currentBooking.uuid,
      isLoading:state.cart.update_sector_loading
  }
}

export default withApollo(connect(mapStateToProps, null)(DaysPanel));